import { WithStyles, withStyles } from "@material-ui/core";
import { push } from "connected-react-router";
import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";

import CustomerInformations from "../../components/CustomerInformations/CustomerInformations";
import CustomerQuotations from "../../components/CustomerQuotations/CustomerQuotations";
import PopinEditCustomer from "../../components/PopinEditCustomer/PopinEditCustomer";
import { User } from "../../models/User.model";
import { setCustomer, setCustomerQuotation } from "../../store/actions";
import { Customer } from "../../types/Customer";
import { RootState } from "../../types/RootState";
import { PageConnected } from "../Page/Page";
import { styles } from "./PageCustomer.style";
import { ActionHistory } from "../../types/ActionHistory";
import { Quotation } from "../../types/Quotation";

type PageCustomerProps = {
    user: User;
    customer: Customer;
    setCustomer: typeof setCustomer;
    setCustomerQuotation: typeof setCustomerQuotation;
    push: typeof push;
};

type PageCustomerState = {
    openEditCustomer: boolean;
};

class PageCustomer extends React.Component<PageCustomerProps & WithStyles<typeof styles>, PageCustomerState> {

    state: PageCustomerState = {
        openEditCustomer: false
    };

    public onActionPerformed(quotation: Quotation, actionHistory: ActionHistory) {
        if ( !quotation.actionHistory ) {
            quotation.actionHistory = [];
        }
        quotation.actionHistory.push(actionHistory);
        this.props.setCustomerQuotation({ customerId: this.props.customer.id, quotation});
    }

    public render() {

        const { classes, customer } = this.props;

        return (
            <PageConnected
                popin={(
                    <PopinEditCustomer
                        customer={customer}
                        open={this.state.openEditCustomer}
                        onCancel={() => this.setState({ openEditCustomer: false })}
                        onChange={this.onChangeCustomer.bind(this)}
                    />
                )}
            >
                <div className={classes.container}>
                    <CustomerInformations customer={this.props.customer} onModifyClick={this.onModifyCustomer.bind(this)}/>
                    <CustomerQuotations onActionPerformed={this.onActionPerformed.bind(this)} customer={this.props.customer} advisor={this.props.user} />
                </div>
            </PageConnected>
        );
    }

    private onChangeCustomer(customer: Customer) {
        this.props.setCustomer(customer);
        this.setState({ openEditCustomer: false });
    }

    private onModifyCustomer() {
        this.setState({ openEditCustomer: true });
    }
}

type PageCustomerConnectedProps = {
    id: string;
};

export const PageCustomerConnected = compose(
    withStyles(styles),
    connect(
        (state: RootState, ownProps: PageCustomerConnectedProps) => {
            return {
                user: state.me.user,
                customer: state.me.userData.customers[ownProps.id],
                customers: state.me.userData ? state.me.userData.customers : {}
            };
        },
        { setCustomer, push, setCustomerQuotation }
    )
)(PageCustomer);

// For stories
export const PageCustomerStyled = withStyles(styles)(PageCustomer);


// WEBPACK FOOTER //
// ./src/pages/PageCustomer/PageCustomer.tsx